import AddOnIds from '../../../constants/addOnIds';
import { formatCurrency } from '../../../utils/pricingUtils';

export const formatMoney = (amount, currency) =>
  amount == null || Number.isNaN(amount) ? '' : formatCurrency(currency, amount, 2);

export const formatDiscount = (amount, currency) =>
  amount == null || Number.isNaN(amount) ? '' : `- ${formatCurrency(currency, amount, 2)}`;

export const getEstimatedNextInvoice = (rating) => {
  const { monthlyPrice, monthlyTaxPrice, addOnRating, promotionData } = rating || {};

  const monthlySum = monthlyPrice + monthlyTaxPrice;
  const addOnRatingSum = addOnRating?.reduce((acc, curr) => acc + curr.monthlyCost + curr.monthlyTax, 0) ?? 0;
  const promotionsAmountSum = promotionData
    ? Object.values(promotionData).reduce((acc, curr) => acc + curr.promotionCredit, 0)
    : 0;

  const estimatedNextInvoice = monthlySum + addOnRatingSum - promotionsAmountSum;

  return estimatedNextInvoice;
};

/**
 * Calculate prorated prepay discount amount
 * For prepay customers (period > 1), returns monthlyDiscount when nextBillDateObject is provided
 *
 * @param {number} monthlyDiscount - Monthly discount amount from backend
 * @param {Date} nextBillDateObject - Next billing date
 * @param {number} period - Billing period (1 = monthly, 12 = annual, etc.)
 * @returns {number} Prorated prepay amount
 */
export const calculateProratedPrepayAmount = (monthlyDiscount, nextBillDateObject, period) => {
  if (monthlyDiscount && nextBillDateObject && period > 1) {
    return monthlyDiscount;
  }

  return 0;
};

/**
 * Calculate SMS line amount based on billing system (CBU-20794)
 * - Stripe: Add discount back to totalPrice to show gross amount, then subtract discount line
 * - BaaS: Show totalPrice as-is (already net amount)
 *
 * @param {Object} rating - Rating object from backend
 * @param {Date} nextBillDateObject - Next billing date
 * @returns {number} SMS line amount to display
 */
export const calculateSmsLineAmount = (rating, nextBillDateObject) => {
  if (!rating || !rating.addOnRating || rating.addOnRating.length === 0) {
    return 0;
  }

  const { stripeQuoteId, addOnRating } = rating;
  const isStripeAccount = Boolean(stripeQuoteId);
  const smsAddOn = addOnRating.find((addOn) => addOn.id === AddOnIds.CTCT_SMS_ADDON);

  if (!smsAddOn) return 0;

  const { totalPrice, monthlyDiscount, period } = smsAddOn;

  // Handle missing or zero totalPrice
  if (!totalPrice || totalPrice === 0) return 0;

  const proratedPrepayAmount = calculateProratedPrepayAmount(monthlyDiscount, nextBillDateObject, period);

  if (isStripeAccount) {
    return totalPrice + proratedPrepayAmount;
  }

  return totalPrice;
};
